import { render } from "./CloneTaskModal.vue?vue&type=template&id=2aa9edc5&scoped=true"
import script from "./CloneTaskModal.vue?vue&type=script&lang=js"
export * from "./CloneTaskModal.vue?vue&type=script&lang=js"

import "./CloneTaskModal.vue?vue&type=style&index=0&id=2aa9edc5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa9edc5"]])

export default __exports__